import { inject, Injectable } from '@angular/core';
import { oofApi, oofDtos } from '@vectronic/openApi-customer';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AddressesRestService {
  private userApi = inject(oofApi.MeUser);

  getOwnAddresses(): Observable<oofDtos.UserAddress[]> {
    return this.userApi.getUserAddresses();
  }
}
